import React from 'react';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden bg-studio-black px-4 py-20" data-id="element-61">
      {/* Background glow effect */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-studio-gold/10 rounded-full blur-[120px] pointer-events-none" data-id="element-62" />

      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 1,
      ease: 'easeOut'
    }} className="z-10 flex flex-col items-center text-center max-w-4xl mx-auto" data-id="element-63">
        <motion.img initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1.2,
        delay: 0.2
      }} src="https://cdn.magicpatterns.com/uploads/koNM2fZivhx8ZdLrpcX3w4/ni_logo.jpg" alt="Bella Beauty Couture Logo" className="w-64 md:w-80 lg:w-96 mb-12 rounded-full shadow-[0_0_50px_rgba(201,168,76,0.2)]" data-id="element-64" />

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="text-4xl md:text-6xl lg:text-7xl font-playfair text-white mb-6 leading-tight" data-id="element-65">
          {t('hero.title1')} <br className="hidden md:block" data-id="element-66" />
          <span className="text-studio-gold italic" data-id="element-67">{t('hero.title2')}</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.7
      }} className="flex items-center gap-2 text-gray-300 mb-8 font-inter tracking-wide text-sm md:text-base uppercase" data-id="element-68">
          <MapPin className="w-4 h-4 text-studio-gold shrink-0" data-id="element-69" />
          <span data-id="element-70">{t('hero.location')}</span>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 0.9
      }} className="text-lg md:text-xl text-gray-400 font-inter max-w-2xl mb-12 font-light" data-id="element-71">
          {t('hero.tagline')}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 1.1
      }} className="flex flex-col sm:flex-row items-center gap-4" data-id="element-72">
          <a href="https://wa.me/17863086806" target="_blank" rel="noopener noreferrer" className="inline-block bg-studio-gold hover:bg-studio-gold-light text-studio-black font-inter font-semibold px-8 py-4 rounded-none tracking-widest uppercase transition-all duration-300 hover:shadow-[0_0_30px_rgba(201,168,76,0.4)] text-center" data-id="element-73">
            {t('hero.bookBtn')}
          </a>
          <a href="#services" className="inline-block border border-studio-gold/50 hover:border-studio-gold text-studio-gold font-inter font-semibold px-8 py-4 rounded-none tracking-widest uppercase transition-all duration-300 hover:bg-studio-gold/10 text-center" data-id="element-74">
            {t('hero.viewServicesBtn')}
          </a>
        </motion.div>
      </motion.div>
    </section>;
}